import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'lib-chips-filter',
    templateUrl: './chips-filter.component.html',
    styleUrls: ['./chips-filter.component.scss'],
    standalone: false
})
export class ChipsFilterComponent {
  @Input() public selectedOption: string;
  @Input() public options: { label: string, key: string }[] = [];

  @Output() public selectOption = new EventEmitter<string>();
  
}
